import { connect } from 'react-redux';
import {
  fetchROPicklists,
  createROPicklist,
  deleteROPicklist
} from '../../../redux/Reservation/sagas/ROPicklist/routines';
import { getIsSaving } from '../../../redux/Reservation/selectors/routes/ro-picklist/create';
import {
  getIsDeleting,
  getIsFetching,
  getOrder
} from '../../../redux/Reservation/selectors/ro-picklist';
import {
  ROPicklistOnClear,
  ROPicklistOnChangePage,
  ROPicklistOnChangeOrder
} from '../../../redux/Reservation/actions/ro-picklist';
import {
  getPaginationLoadedPages,
  getPaginationWithoutPages,
  getPaginationQueryOptions,
  getCurrentPageItems
} from '../../../redux/Reservation/selectors/ro-picklist/pagination';
import { getROPicklistSearchQuery } from '../../../redux/Reservation/selectors/components/ro-picklist-search';
import paginationAndSearchQuery from '../../../helpers/paginationAndSearchQuery';
import ROPicklistList from '../../../components/reservations/ROPicklistList';
import orderList from '../../../helpers/orderList';
import clonePicklist from '../../../helpers/clonePicklist';

function mapStateToProps(state) {
  const paginationQuery = getPaginationQueryOptions(state);
  const searchQuery = getROPicklistSearchQuery(state);
  const order = getOrder(state);
  return {
    items: orderList(order, getCurrentPageItems(state)),
    query: { ...paginationAndSearchQuery(paginationQuery, searchQuery), order },
    loadedPages: getPaginationLoadedPages(state),
    pagination: getPaginationWithoutPages(state),
    isFetching: getIsFetching(state),
    isCloning: getIsSaving(state),
    isDeleting: getIsDeleting(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      dispatch(fetchROPicklists());
    },
    onChangePage: (query, isPageLoaded) => {
      const { page } = query;
      if (!isPageLoaded) dispatch(fetchROPicklists(query));
      else dispatch(ROPicklistOnChangePage(page));
    },
    onChangeLimit: query => {
      dispatch(ROPicklistOnClear());
      dispatch(fetchROPicklists(query));
    },
    onSort: (sortBy, sortOrder, query) => {
      const order = `${sortBy}:${sortOrder}`;
      dispatch(ROPicklistOnClear());
      dispatch(fetchROPicklists({ ...query, order }));
      dispatch(ROPicklistOnChangeOrder(order));
    },
    onClone: picklist => {
      dispatch(createROPicklist({ body: clonePicklist(picklist) }));
    },
    onDelete: picklist => {
      dispatch(deleteROPicklist(picklist));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ROPicklistList);
